import { useEffect } from "react";
import { useRouter } from "next/router";
import dynamic from "next/dynamic";
import { pageName, triggerLinkClick } from "lib/utils/events_utils";
import { trackPage } from "scripts/segment";
import { COUNTRY_LIST } from "constant";
import { logPageView } from "components/Analytics/google-analytics";
import Overview from "components/Product/Overview";
import Layout from "components/Layout";
import { getTokenCookie } from "lib/auth-cookies-new";

const Features = dynamic(() => import("components/Product/Features"));
const Contact = dynamic(() => import("components/Product/Contact"));
const Calculate = dynamic(() => import("components/Product/Calculate"));
const LoanSteps = dynamic(() => import("components/Product/LoanSteps"));
const Eligibility = dynamic(() => import("components/Product/Eligibility"));
const MainFooter = dynamic(() => import("components/MainFooter"));

export default ({ featuresInBrief, featuresInDetail, isLoggedIn }) => {
  const router = useRouter();
  const { clickId } = router.query || {};

  useEffect(() => {
    logPageView();
    trackPage(pageName.INSCHOOL_LOAN_FEATURES_US_PAGE);
    clickId && triggerLinkClick(clickId);
  }, []);

  return (
    <Layout
      title="Loan Features - Fund your future with Leap's Post Graduate Student Loans"
      showNavLinks
      invertLogo={false}
      showBackground
      description="Explore Leap Finance education loans for Indian students pursuing MS in the USA. Get 100% funding for tuition & living expenses, with no collateral required & flexible repayment options. Apply now!"
      isLoggedIn={isLoggedIn}
    >
      {(user) => {
        return (
          <div className="product-container">
            <Overview
              user={user}
              country={COUNTRY_LIST.USA}
              features={featuresInBrief}
            />
            <Features
              user={user}
              country={COUNTRY_LIST.USA}
              features={featuresInDetail}
            />
            <LoanSteps />
            <Contact />
            <Calculate />
            <Eligibility user={user} />
            <MainFooter />
          </div>
        );
      }}
    </Layout>
  );
};

export const getServerSideProps = async (context) => {
  context.res.setHeader(
    "Cache-Control",
    "public, s-maxage=31536000, stale-while-revalidate"
  );
  const props = {};
  try {
    const axios = (await import(`axios`)).default;
    const res = await axios.get(
      `${process.env.KnowledgeBaseURL}/constants?key=lf-loan-features-usa-in-brief&key=lf-loan-features-usa-in-detail`
    );
    props.featuresInBrief = res.data[0].jsonValue.features;
    props.featuresInDetail = res.data[1].jsonValue.features;
  } catch (error) {
    console.error(error);
  } finally {
    props.isLoggedIn = !!getTokenCookie(context);
    return { props };
  }
};
